import styled from 'styled-components';

export const Box = styled.div`
  ${(props) => props.marginLeft ? `margin-left: ${props.marginLeft};` : ''}
  background-color: transparent;
  border-radius: 10px;
  ${(props) => props.width ? `width: ${props.width};` : ''}
  ${(props) => props.height ? `height: ${props.height};` : ''}
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  ${(props) => props.paddingTop ? `padding-top: ${props.paddingTop};` : ''}
  ${(props) => props.paddingLeft ? `padding-left: ${props.paddingLeft};` : ''}

  @media(max-width === 1000){
    padding-left: '';
  }
`;
